import React, {useContext} from 'react'
import {MainContext} from "contexts/main.context";
import {Box, Button, Grid, Switch, TextField, Tooltip, Typography} from '@material-ui/core';
import 'moment/locale/es';
import SubHeader from "components/helpers/subHeader/subHeader";
import {ReactGrid} from "components/helpers/reactGrid/reactGrid";
import DeleteIcon from "@material-ui/icons/Delete";

export function ArticulosArmadosOperation({
                                              operation,
                                              id,
                                              articulos,
                                              tableConfig,
                                              codigo,
                                              setCodigo,
                                              detalle,
                                              setDetalle,
                                              activo,
                                              setActivo,
                                              condVta30Dias,
                                              setCondVta30Dias,
                                              onOpenAddArticulosDialog,
                                              onDelete,
                                              articulosList,
                                              onChangeDocument
                                          }) {
    const context = useContext(MainContext);
    const {loggedUser} = context;

    return (
        <Box className='niquel-articulosArmados-operation'>
            <SubHeader
                title={'Articulos Armados'}
                subtitle={
                    operation === 'VIEW' ?
                        'Revisión de Artículo Armado' :
                        operation === 'EDIT' ?
                            'Edición de Articulo Armado' :
                            'Nuevo Artículo Armado'
                }
                optionsTitle={'Artículo Armado'}
                options={id && articulosList && articulosList.length > 0 ? [...articulosList].reverse() : undefined}
                optionSelectedId={id}
                optionsDescriptionField={'id'}
                optionsDescriptionSecondaryField={'detalle'}
                onChangeOption={onChangeDocument}
            />
            <Box className='container-xl mt-3 mb-3'>
                <Grid container alignItems='center'>
                    <Grid container item alignItems='center' spacing={2} md={12}>
                        <Grid item>
                            <TextField
                                label="Código"
                                value={codigo}
                                onChange={event => setCodigo(event.target.value.substring(0, 11))}
                                InputProps={{
                                    readOnly: (operation === 'VIEW' || operation === 'EDIT')
                                }}
                                style={{
                                    width: '8rem'
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <TextField
                                label="Detalle del artículo armado"
                                value={detalle}
                                onChange={event => setDetalle(event.target.value.substring(0, 60))}
                                InputProps={{
                                    readOnly: operation === 'VIEW'
                                }}
                                style={{
                                    width: '25rem'
                                }}
                            />
                        </Grid>
                        <Grid item>
                            <Switch
                                checked={activo}
                                disabled={operation === "VIEW"}
                                color={"primary"}
                                onChange={() => setActivo(!activo)}
                            />
                            <Typography
                                variant={"caption"}
                                component={"span"}
                                onClick={() => operation !== "VIEW" && setActivo(!activo)}
                                style={{cursor: 'pointer'}}
                                color={'textPrimary'}
                            >
                                {activo ? "ACTIVO" : "INACTIVO"}
                            </Typography>
                        </Grid>
                        <Grid item className={'ml-3'}>
                            <Switch
                                checked={condVta30Dias}
                                disabled={operation === "VIEW"}
                                color={"primary"}
                                onChange={() => setCondVta30Dias(!condVta30Dias)}
                            />
                            <Typography
                                variant={"caption"}
                                component={"span"}
                                onClick={() => operation !== "VIEW" && setCondVta30Dias(!condVta30Dias)}
                                style={{cursor: 'pointer'}}
                                color={'textPrimary'}
                            >
                                {condVta30Dias ? "Cond. Vta. 30 días" : "Cond. Vta. 30 días"}
                            </Typography>
                        </Grid>
                        {(operation === 'VIEW' || operation === 'EDIT') && loggedUser.role !== 'V' &&
                            <Grid item className={'ml-2'}>
                                <Tooltip title={'Eliminar Artículo Armado'}>
                                    <Button className={'background-error'} style={{color: 'white'}} onClick={onDelete}>
                                        <DeleteIcon fontSize={"small"}/> ELIMINAR
                                    </Button>
                                </Tooltip>
                            </Grid>
                        }
                    </Grid>
                </Grid>

                <Box className={'mt-3'}>
                    {tableConfig &&
                        <ReactGrid
                            enableVirtualMode={false}
                            columns={tableConfig.columns}
                            columnExtensions={tableConfig.columnExtensions}
                            getRowId={row => row.id}
                            rows={articulos}
                            title={`Artículos`}
                            showResultCount={true}
                            enableFiltering={false}
                            enableSorting={true}
                            enableSearch={false}
                            enableSelection={false}
                            enableGrouping={true}
                            enableSummarizing={true}
                            showAddButton={operation !== 'VIEW'}
                            onClickAddButton={onOpenAddArticulosDialog}
                            showSelectAll={true}
                        />
                    }
                </Box>
            </Box>
        </Box>
    )
}
